import React, { Component } from 'react';
import { Modal, Input, Radio, Checkbox, Spin, Button, message, Select } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import SearchMulRetrieve from '../../common/SearchMulRetrieve';
import RequirementInfoContent from './components/RequirementInfoContent';
import SiteSituation from './components/SiteSituation';
import Text from '../../basicElement/Text';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import format from '../../shared/format';
import moment from 'moment';
import { AcquireStatus, RequirementInfo, Default, Storage } from './constants';

const { TextArea } = Input;
const RadioGroup = Radio.Group;
const monthFormat = 'YYYY-MM';
const typeInConfig = {
    add: {
        title: '新建计划需求',
        message: '新建成功',
        url: API_URL.member.addRequirement,
        requirementOrigin: 'CREATE',
    },
    copy: {
        title: '复制新建',
        message: '复制成功',
        url: API_URL.member.addRequirement,
        requirementOrigin: 'CREATE',
    },
    supply: {
        title: '补充人员需求',
        message: '补充成功',
        url: API_URL.member.addRequirement,
        requirementOrigin: 'SUPPLEMENT',
    },
    edit: {
        title: '修改需求',
        message: '修改成功',
        url: API_URL.member.editRequirement,
    }
};
const RelateTip = '此中心尚未关联JDE项目号，不可发起人员需求';

const genOptions = data => Object.keys(data).map(i => <Radio key={i} value={i}>{ data[i] }</Radio>);
const genConfig = (type) => {
    return {
        ...typeInConfig[type],
        [type]: true
    };
};
const genReqInfoByInvNature = (invNature, params) => {
    const before = { ...params };
    const after = {
        ...params,
        requirementInfoType: 'AFTER_STARTUP_MEMBER'
    };

    switch (invNature) {
        case '启动前':
            return { before };
        case '启动后':
            return { after };
        default:
            return { before, after };
    }
};

const AcquireStatusOption = genOptions(AcquireStatus, 'radio');
const DefaultOption = genOptions(Default, 'radio');

let config = {};

/**
 * 需求类型有四种情况：
 * 1.项目性质为‘启动前’：启动前
 * 2.项目性质为‘启动后’：启动后
 * 3.项目性质为‘启动前 + 启动后’：启动前 + 启动后
 * 4.是否为临床项目为否或项目性质为‘-’：需要选择，选项为启动前、启动后
 */

class Update extends Component {
    constructor(props) {
        super(props);
        this.noFte = false;
        this.isAsh = false;
        this.isRelated = false;            // 中心是否关联合同
        this.shouldSelect = false;         // 是否为临床项目为否、且项目性质为‘-’时： 为true, 表示需要勾选需求类型
        this.siteStartTime = undefined;
        this.isHistory = false;            // 是否是历史项目，PI不存在就认为是
        this.record = {};
        this.state = {
            visible: false,
            loading: false,
            saveParams: {},
            isGivenSecondLines: false,
            sitePlanFteCal: false,
        };
    }

    // 查询中心
    querySite = (investigationSiteId) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationSiteByKeyword,
            data: {
                limit: 20,
                invId: Storage.invId,
                filterSite: !this.isHistory && 'TRUE',
                investigationSiteId,
            },
            doneResult: res => {
                const data = res.data.siteList.datas || [];
                data.forEach(item => {
                    const { investigationSiteId, investigationSiteName, investigationSiteCode } = item;
                    item.value = investigationSiteId;
                    item.text = format('joint', investigationSiteName, investigationSiteCode, 'roundBrackets');
                });
                this.setState({ loading: false }, () => {
                    const [item] = data;
                    if (item) {
                        this.handleChange(item, 'invSite');
                    }
                });
            },
        };
        $.sendRequest(options);
    }

    loadData = () => {
        const { requirementId } = this.record;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.member.getRequireMents,
            data: {
                requirementId,
                isCopying: config.copy,
                isSupport: config.supply ? 1 : undefined,
                requirementType: 'InvestigationRequest',
            },
            doneResult: res => {
                const { isAsh, requirement, requirementInfo, requirementPiList } = res.data;
                const { site, noFte, requirementCode } = requirement || {};
                const {
                    currentInvestigationProgress,
                    afterBeforeStartupSameMember,
                    investigationAcquisitionStatus,
                } = requirementInfo || {};
                const { city, startTime, invNature, haveContract, investigationSiteId, investigationSiteName, investigationSiteCode,courtyardArea,departmentName } = site || {};

                if ((requirementPiList || []).length) {
                    let { saveParams } = this.state;
                    saveParams = {
                        ...saveParams,
                        requirementCode,
                        investigationAcquisitionStatus,
                        afterBeforeStartupSameMember: typeof afterBeforeStartupSameMember === 'number' ? String(afterBeforeStartupSameMember) : undefined,
                        currentInvestigationProgress,
                    };
                    if (config.edit || config.supply) {
                        saveParams.courtyardArea = courtyardArea;
                        saveParams.departmentName = departmentName;
                        saveParams.city = city;
                        saveParams.invSiteId = investigationSiteId;
                        saveParams.invSiteName = format('joint', investigationSiteName, investigationSiteCode, 'roundBrackets');
                        saveParams.investigationSiteName = investigationSiteName;
                        saveParams.investigationSiteCode = investigationSiteCode;
                        saveParams.piIds = (requirementPiList || []).map(i => i.userId).join(',');
                    }
                    if (
                        (!invNature || invNature === '启动前+启动后') &&
                        (config.copy || config.supply) 
                    ) {
                        this.shouldSelect = true;
                        const params = {};
                        // 默认显示添加时的勾选状态
                        Object.keys(RequirementInfo).forEach(type => {
                            if (saveParams.requirementInfo[type]) {
                                params[type] = {...saveParams.requirementInfo[type]};
                                params[type].selected = true;
                            } else {
                                params[type] = {};
                            }
                            if (type === 'after') {
                                params[type].requirementInfoType = 'AFTER_STARTUP_MEMBER';
                            }
                        });
                        saveParams.requirementInfo = params;
                    }
                    if (startTime) {
                        Object.keys(saveParams.requirementInfo).forEach(type => {
                            saveParams.requirementInfo[type].planStartupTime = startTime;
                        });
                    }
                    this.initialDate(saveParams.requirementInfo);
    
                    this.noFte = noFte !== undefined ? noFte : true;
                    this.isAsh = isAsh;
                    this.isRelated = haveContract;
                    this.siteStartTime = startTime;
                    this.setState({
                        saveParams,
                        loading: false,
                    }, () => {
                        if (config.edit || config.supply) {
                            this.piRef.queryData();
                        }
                        this.queryInvestigationSecondLines();
                    });
                } else {
                    this.isHistory = true;
                    this.querySite(investigationSiteId);
                }
            },
        };
        $.sendRequest(options);
    }

    getReqFteList = () => {
        const { requirementId } = this.record;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.member.getReqFteList,
            data: {
                requirementId,
                isCopying: config.copy,
                requirementType: 'InvestigationRequest',
            },
            doneResult: res => {
                let { saveParams } = this.state;

                Object.keys(res || {}).forEach(key => {
                    const { fteList } = res[key] || {};
                    if (saveParams.requirementInfo[key]) {
                        saveParams.requirementInfo[key].fteList = (fteList || []).map(item => {
                            const { year, month, fte } = item;
                            return [format('month', year, month), fte];
                        });
                    }
                });

                this.setState({
                    saveParams,
                    loading: false,
                });
            },
        };
        $.sendRequest(options);
    }

    show = (record = {}, type, callback) => {
        config = genConfig(type);
        this.record = record;
        this.shouldSelect = false;
        this.isHistory = false;

        const saveParams = {};

        if (config.edit || config.supply) {
            const { current, ...rest } = record.requirementInfos;
            saveParams.requirementInfo = current ? { [current]: rest[current] } : rest;
        } else if (config.copy) {
            const { current, ...rest } = record.requirementInfos;
            saveParams.requirementInfo = rest;
        }

        this.setState({
            visible: true,
            saveParams,
        }, () => {
            if (config.add && Storage.isConcrete) {
                const { siteId } = sessionStorage;
                this.querySite(siteId);
            } else if (!config.add) {
                this.loadData();
                this.getReqFteList();
            }
        });
        this.queryInvestigationSecondLines();
    }

    hide = () => {
        this.setState({
            visible: false,
            saveParams: {},
        });
    }

    queryInvestigationSecondLines = () => {
        //判断是否为执行业务线二级分类为“SSU主导、启动前协助、启动前协助+启动后常规CRC执行、启动后常规CRC执行、非盲”的项目
        const { invId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationSecondLines,
            data: { invId },
            dataType: 'json',
            doneResult: res => {
                const { secondLines, sitePlanFteCal } = res;
                const givenSecondLines = ['SSU主导','启动前协助','启动前协助+启动后常规CRC执行','启动后常规CRC执行','非盲'];
                const isGivenSecondLines = givenSecondLines.includes(secondLines) && sitePlanFteCal;
                if (isGivenSecondLines) {
                    const { investigationSiteId } = this.record;
                    this.querySitePlanFteMonth(investigationSiteId);
                }
                this.setState({
                    isGivenSecondLines,
                    sitePlanFteCal,
                });
            }
        };
        $.sendRequest(options);
    }

    querySitePlanFteMonth = (investigationSiteId) => {
        if (!investigationSiteId) {
            return
        }
        const options = {
            url: API_URL.plan.querySitePlanFteMonth,
            data: {
                investigationSiteId,
                afterTotal: true,
                type: 'forAddRequirement',
            },
            dataType: 'json',
            doneResult: res => {
                const { beforeStartSiteFtes, afterStartSiteFtes } = res;
                const obj = {
                    before: beforeStartSiteFtes,
                    after: afterStartSiteFtes,
                };

                let { saveParams } = this.state;

                Object.keys(obj).forEach(key => {
                    if (saveParams.requirementInfo[key]) {
                        saveParams.requirementInfo[key].fteList = obj[key]
                    }
                });

                this.setState({
                    saveParams,
                });
            },
        };
        $.sendRequest(options);
    }

    // 设置FTE开始、结束日期
    initialDate = (requirementInfo) => {
        const { planEndTime } = this.props;
        const startMonth = moment().format(monthFormat);
        const endMonth = moment(planEndTime).format(monthFormat);

        Object.keys(requirementInfo || {}).forEach(key => {
            requirementInfo[key].startMonth = startMonth;
            requirementInfo[key].endMonth = endMonth;
        });
    }

    handleChange = (value, key) => {
        const { saveParams, sitePlanFteCal } = this.state;
        
        switch (key) {
            case 'invSite': {
                const { value: id, text: name, city, invNature, startTime, haveContract, investigationSiteName, investigationSiteCode, courtyardArea, departmentName } = value;
                this.siteStartTime = startTime ? format('date', startTime) : '';
                this.isRelated = haveContract;
                saveParams[`${key}Id`] = id;
                saveParams[`${key}Name`] = name;
                saveParams.investigationSiteName = investigationSiteName;
                saveParams.investigationSiteCode = investigationSiteCode;
                saveParams.city = city;
                saveParams.courtyardArea = courtyardArea;
                saveParams.departmentName = departmentName;
                saveParams.piIds = undefined;
                saveParams.planStartupTime = format('date', startTime);

                if (config.add || this.isHistory) {
                    if (id) {
                        if (
                            !invNature ||
                            (invNature === '启动前+启动后' && (config.copy ||config.supply))) {
                            this.shouldSelect = true;
                        }
                        const defaultParams = {};
                        if (this.siteStartTime) {
                            defaultParams.planStartupTime = this.siteStartTime;
                        }
                        saveParams.requirementInfo = genReqInfoByInvNature(invNature, defaultParams);
                        this.initialDate(saveParams.requirementInfo);
                    } else {
                        this.shouldSelect = false;
                        saveParams.requirementInfo = {};
                    }
                } else if (config.copy) {
                    if (this.siteStartTime) {
                        Object.keys(saveParams.requirementInfo).forEach(item => {
                            saveParams.requirementInfo[item].planStartupTime = this.siteStartTime;
                        });
                    }
                }
                if (sitePlanFteCal) {
                    this.querySitePlanFteMonth(id);
                }

                this.setState({ saveParams });
                break;
            }
            default:
                saveParams[key] = value;
                this.setState({ saveParams });
                break;
        }
    }

    handleSearchChange = (value, option, key) => {
        const { saveParams } = this.state;
        let list = saveParams[key] ? saveParams[key].split(',') : [];
        if (option) {
            list.push(option.value);
        } else {
            list = list.filter(i => i != value);
        }
        saveParams[key] = list.join(',');
        this.setState({ saveParams });
    }

    handleRequirementInfoChange = (value, key, type) => {
        const { saveParams } = this.state;
        const { requirementInfo } = saveParams;
        
        requirementInfo[type][key] = value;

        // 同步planStartupTime
        const requirementInfoKeys = Object.keys(requirementInfo || {});
        if (requirementInfoKeys.length > 1) {
            if (key === 'planStartupTime') {
                requirementInfoKeys.forEach(type => requirementInfo[type][key] = value);
            } else if (key === 'selected') {
                if (!requirementInfo[type].planStartupTime) {
                    let planStartupTime = null;
                    requirementInfoKeys.forEach(t => {
                        if (t !== type) {
                            planStartupTime = requirementInfo[t].planStartupTime;
                        }
                    });
                    requirementInfo[type].planStartupTime = planStartupTime;
                }
            }
        }

        this.setState({ saveParams });
    }

    validate = () => {
        const { saveParams } = this.state;
        if (saveParams.invSiteId && !this.isRelated) {
            Modal.confirm({
                iconType: 'exclamation-circle',
                title: RelateTip,
                okText: '现在去关联',
                onOk: () => {
                    this.props.relate(saveParams);
                },
                cancelText: '知道了',
            });
        } else {
            this.confirm();
        }
    }

    confirm = () => {
        const { saveParams, isGivenSecondLines, beforeStartSiteFtes, afterStartSiteFtes } = this.state;
        const {
            requirementCode,
            invSiteId,
            piIds,
            investigationAcquisitionStatus,
            requirementInfo,
            afterBeforeStartupSameMember,
            currentInvestigationProgress,
        } = saveParams;
        const requirementInfoKeys = Object.keys(requirementInfo || {});

        if (!invSiteId) {
            return message.warning('中心不能为空!');
        }
        if (!piIds) {
            return message.warning('请选择PI!');
        }
        if (!investigationAcquisitionStatus) {
            return message.warning('请选择项目获得状态!');
        }

        let params = {};
        let hasSelected = false;
        let hasAllSelected = true;
        for (let key of requirementInfoKeys) {
            const { requirementId, requirementInfoType, fteList, comment, planOnDutyTime, planStartupTime, selected } = requirementInfo[key] || {};
            if (this.shouldSelect) {
                hasAllSelected = hasAllSelected ? !!selected : false;
            }
            if (!this.shouldSelect || (this.shouldSelect && selected)) {
                if (selected) {
                    hasSelected = true;
                }
                if (!requirementInfoType) {
                    return message.warning('请选择启动前类型!');
                }

                if (isGivenSecondLines) {
                    if (!(fteList || []).length) {
                        return message.warning('请填写FTE需求!');
                    } else {
                        (fteList || []).map((el, index) => {
                            const { year, month, value } = el;
                            params[`${key}.fteList[${index}].year`] = year;
                            params[`${key}.fteList[${index}].month`] = month;
                            params[`${key}.fteList[${index}].fte`] = value;
                        })
                    }
                } else {
                    if (!(fteList || []).length) {
                        return message.warning('请填写FTE需求!');
                    } else {
                        for (let i = 0, len = fteList.length; i < len; i++) {
                            const [ date, fte ] = fteList[i];
                            if (!date || (!fte && fte !== 0)) {
                                return message.warning('请将FTE填写完整!');
                            }
                            params[`${key}.fteList[${i}].year`] = moment(date).format("YYYY");
                            params[`${key}.fteList[${i}].month`] = moment(date).format("MM");
                            params[`${key}.fteList[${i}].fte`] = fte;
                        }
                    }
                }

                if (comment && comment.length > 250) {
                    return message.warning('您输入的内容过多，请重新输入（限制250字符）');
                }
                if (!planOnDutyTime) {
                    return message.warning('请选择预计上岗时间!');
                }
                if (!planStartupTime) {
                    return message.warning('请选择预计/实际启动时间!');
                }
                if (config.edit) {
                    params[`${key}.requirementId`] = requirementId;
                }
                params[`${key}.requirementInfoType`] = requirementInfoType;
                params[`${key}.requirementComment`] = comment;
                params[`${key}.planOnDutyTimeStr`] = format('date', planOnDutyTime);
                params[`${key}.planStartupTimeStr`] = format('date', planStartupTime);
            }
        }
        if (this.shouldSelect && !hasSelected) {
            return message.warning('请选择需求类型!');
        }
        if (
            requirementInfoKeys.length > 1 &&
            (!this.shouldSelect || (this.shouldSelect && hasAllSelected)) &&
            !afterBeforeStartupSameMember
        ) {
            return message.warning('请选择启动前后是否要求同一人!');
        }
        if (currentInvestigationProgress && currentInvestigationProgress.length > 250) {
            return message.warning('您输入的内容过多，请重新输入（限制250字符）');
        }

        if (config.requirementOrigin) {
            params.requirementOrigin = config.requirementOrigin;
        }
        if (config.supply) {
            params.requirementCode = requirementCode;
        }
        if (requirementInfoKeys.length > 1 && hasAllSelected) {
            params.afterBeforeStartupSameMember = afterBeforeStartupSameMember;
        }

        params = {
            ...params,
            invSiteId,
            investigationAcquisitionStatus,
            currentInvestigationProgress
        };
        piIds.split(',').forEach((item, index) => params[`ids[${index}]`] = item);

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: config.url,
            data: { ...params },
            doneResult: () => {
                message.success(config.message);
                this.hide();
                this.setState({
                    loading: false
                }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }
    
    getContent = () => {
        const { planBeginTime, planEndTime } = this.props;
        const { saveParams, isGivenSecondLines } = this.state;
        const { invSiteId, city, piIds, requirementInfo, courtyardArea, departmentName } = saveParams;
        

        const params = {
            noFte: this.noFte,
            isAsh: this.isAsh,
            siteStartTime: this.siteStartTime,
            planBeginTim: planBeginTime,
            planEndTime: planEndTime,
        };
        const requirementInfoKeys = Object.keys(requirementInfo || {});
        const disabled_site = Storage.isConcrete || (config.edit || config.supply);
        const disabled = config.supply && !this.isHistory;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={!disabled_site} colon={true}>中心名称(中心编号)</Text></div>
                    <div className="item-right" style={{ position: 'relative' }}>
                        <div>
                            <SearchRetrieve
                                disabled={disabled_site}
                                keyword='keyword'
                                style={{ width: 300 }}
                                placeholder="输入名称/编号检索"
                                value={saveParams.invSiteName}
                                params={{ limit: 20, invId: Storage.invId, filterSite: 'TRUE' }}
                                url={API_URL.investigation.queryInvestigationSiteByKeyword}
                                config={{ id: 'investigationSiteId', name: 'investigationSiteName', code: 'investigationSiteCode', type: 'site', show: 'invSite' }}
                                onChange={value => this.handleChange(value, 'invSite')}
                            />
                            <Button
                                className="btn-green"
                                disabled={!saveParams.invSiteId}
                                style={{ position: 'absolute', right: 0 }}
                                onClick={() => this.showSiteSituation(saveParams.invSiteId)}
                            >中心知情、筛选、随机(入组)情况</Button>
                        </div>
                        {
                            saveParams.invSiteId && !this.isRelated &&
                            <p style={{ color: '#F00' }}>{RelateTip}</p>
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={false} colon={true}>院区</Text></div>
                    <div className="item-right">{courtyardArea}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={false} colon={true}>科室</Text></div>
                    <div className="item-right">{departmentName}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={false} colon={true}>城市</Text></div>
                    <div className="item-right">{city}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={!disabled} colon={true}>PI</Text></div>
                    <div className="item-right">
                        <SearchMulRetrieve
                            ref={el => this.piRef = el}
                            keyword="keyWord"
                            placeholder="输入姓名/手机号检索"
                            style={{width: 300}}
                            //disabled={!invSiteId || disabled} // 需要完全放开可编辑权限
                            value={piIds ? piIds.split(',') : []}
                            params={{limit: 20, investigationSiteId: invSiteId}}
                            url={API_URL.member.querySitePi}
                            config={{ id: 'userId', name: 'userName', code: 'userMobile', show: 'parentheses' }}
                            onChange={(value, option) => this.handleSearchChange(value, option, 'piIds')}
                        />
                        <p style={{ color: '#999' }}>（若无相应PI信息，请先去“研究中心-参与临床试验人员信息”页面添加）</p>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={!disabled} colon={true}>项目获得状态</Text></div>
                    <div className="item-right">
                        <RadioGroup
                            disabled={disabled}
                            value={saveParams.investigationAcquisitionStatus}
                            onChange={e => this.handleChange(e.target.value, 'investigationAcquisitionStatus')}
                        >
                            { AcquireStatusOption }
                            {/* <span className="clearValue" onClick={() => this.handleRemove('cashReqNodeType')}>×</span> */}
                        </RadioGroup>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={true} colon={true}>需求类型</Text></div>
                    <div className="item-right">
                        {
                            requirementInfoKeys.map(item => (
                                <div key={item}>
                                    <div style={{ minHeight: 24 }}>
                                        {
                                            this.shouldSelect ?
                                                <Checkbox checked={requirementInfo[item].selected} onChange={e => this.handleRequirementInfoChange(e.target.checked, 'selected', item)}>{RequirementInfo[item]}</Checkbox>
                                            :
                                                RequirementInfo[item]
                                        }
                                    </div>
                                    {
                                        (
                                            !this.shouldSelect ||
                                            (this.shouldSelect && requirementInfo[item].selected)
                                        ) &&
                                        <RequirementInfoContent
                                            params={params}
                                            type={item}
                                            isGivenSecondLines={isGivenSecondLines}
                                            data={requirementInfo[item] || {}}
                                            onChange={(value, key) => this.handleRequirementInfoChange(value, key, item)}
                                        />
                                    }
                                </div>
                            ))
                        }
                    </div>
                </li>
                {
                    requirementInfoKeys.length > 1 &&
                    (!this.shouldSelect || (this.shouldSelect && requirementInfoKeys.every(item => requirementInfo[item].selected))) &&
                    <li className="modal-item">
                        <div className="item-left"><Text asterisk={true} colon={true}>启动前后是否要求同一人</Text></div>
                        <div className="item-right">
                            <RadioGroup
                                value={saveParams.afterBeforeStartupSameMember}
                                disabled={this.shouldSelect && (!requirementInfo[requirementInfoKeys[0]].selected || !requirementInfo[requirementInfoKeys[1]].selected)}
                                onChange={e => this.handleChange(e.target.value, 'afterBeforeStartupSameMember')}
                            >
                                { DefaultOption }
                                {/* <span className="clearValue" onClick={() => this.handleRemove('cashReqNodeType')}>×</span> */}
                            </RadioGroup>
                        </div>
                    </li>
                }
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={false} colon={true}>目前项目进度</Text></div>
                    <div className="item-right">
                        <TextArea
                            rows={4}
                            placeholder='请输入'
                            value={saveParams.currentInvestigationProgress}
                            onChange={e => this.handleChange(e.target.value, 'currentInvestigationProgress')}
                        />
                    </div>
                </li>
            </ul>
        );
    }

    showSiteSituation = (invSiteId) => {
        this.siteRef.show(invSiteId);
    }

    render() {
        const { loading, visible } = this.state;
        return (
            <Modal
                title={config.title}
                visible={visible}
                onOk={this.validate}
                onCancel={this.hide}
                width="800px"
                maskClosable={false}
                bodyStyle={{ maxHeight: 500 }}
                confirmLoading={loading}
            >
                <Spin spinning={loading}>
                    <div className="modal-content form-list" style={{padding: 0}}>
                        {this.getContent()}
                    </div>
                </Spin>
                <SiteSituation ref={el => this.siteRef = el} />
            </Modal>
        );
    }
}

export default Update;



// WEBPACK FOOTER //
// ./src/components/user/require/Update.js